import { render, staticRenderFns } from "./start-editor.vue?vue&type=template&id=6883e532&scoped=true&lang=pug"
import script from "./start-editor.vue?vue&type=script&lang=coffee"
export * from "./start-editor.vue?vue&type=script&lang=coffee"
import style0 from "./start-editor.vue?vue&type=style&index=0&id=6883e532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883e532",
  null
  
)

export default component.exports